module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_9016.ff2070d7.png";